import {
  loginRequest,
  registerRequest,
  logoutRequest,
  verifyEmailRequest,
  resendOtpRequest,
  forgotPasswordRequest,
  resetPasswordRequest,
  changePasswordRequest,
  changeEmailRequest,
  confirmEmailChangeRequest,
} from '../api/auth.api';

export const login = async (data) => {
  const res = await loginRequest(data);
  return res.data;
};

export const register = async (data) => {
  const res = await registerRequest(data);
  return res.data;
};

export const logout = async () => {
  await logoutRequest();
};

export const verifyEmail = async (data) => {
  const res = await verifyEmailRequest(data);
  return res.data;
};

export const resendOtp = async (data) => {
  const res = await resendOtpRequest(data);
  return res.data;
};

export const forgotPassword = async (data) => {
  const res = await forgotPasswordRequest(data);
  return res.data;
};

export const resetPassword = async (data) => {
  const res = await resetPasswordRequest(data);
  return res.data;
};

export const changePassword = async (data) => {
  const res = await changePasswordRequest(data);
  return res.data;
};

export const initiateEmailChange = async (data) => {
  const res = await changeEmailRequest(data);
  return res.data;
};

export const confirmEmailChange = async (data) => {
  const res = await confirmEmailChangeRequest(data);
  return res.data;
};
